
import {
	Component,
	Input
} from '@angular/core';

import {
	Dd1pndsNgRedirectionService
} from 'dd1pnds-ngx-services';

import {
	FaqItemModel
} from './../../models/landing-page/faq/faq.model';

@Component({
	selector: 'dd1pnds-ng-faq-content',
	templateUrl: './dd1pnds-ng-faq-content.component.html',
})
export class Dd1pndsNgFaqContentComponent {
	@Input() faqItems: FaqItemModel[];

	constructor(
		private redirectionService: Dd1pndsNgRedirectionService
	) { }

	/**
	 * Action quand on clique sur le lien d'un contenu de type 'lien'.
	 */
	public redirectToPage(url: string): void {
		this.redirectionService.manageRedirectPage(url);
	}
}
